import React, { memo, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { subscriptionsList } from '../../services/subscriptions';

import Table from '../../components/Table';
import { useNavigate } from 'react-router-dom';

const SubscriptionsList = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [list, setList] = useState([]);

  const getList = async () => {
    const { subscriptions } = await subscriptionsList();
    setList(subscriptions);
  };

  useEffect(() => {
    getList();
  }, [i18n.language]);

  const columns = useMemo(
    () => [
      {
        header: t('common.table_title'),
        accessorKey: 'title',
        cell: info => (
          <div onClick={() => navigate('/club_admin/subscriptions/' + info.row.original?.id)}>
            <span
              className="premiums-circle"
              style={{ backgroundColor: '#' + info.row.original?.premium?.color }}
            ></span>
            {info.row.original?.premium?.title}
          </div>
        ),
      },
      {
        header: t('subscriptions.expires'),
        accessorKey: 'expires_at',
        cell: info => info.getValue(),
        meta: { style: { width: 200 } },
      },
      {
        id: 'actions',
        header: ' ',
        cell: info => (
          <div className="flex-end ai-center">
            <i
              className="icon icon-settings"
              onClick={() => navigate('/club_admin/subscriptions/' + info.row.original?.id)}
            ></i>
          </div>
        ),
        meta: { style: { width: 60 } },
      },
    ],
    [i18n.language]
  );

  return (
    <div className="team-details">
      <div className="team-details-header">
        <div className="team-details-header-text">{t('subscriptions.title')}</div>
        <a href={`mailto:Hello@supercoachapp.com?subject=${`Buy more licenses`}`} className="button button-add">
          {t('subscriptions.purchase')}
        </a>
      </div>
      <div className="team-details-list">
        <Table {...{ data: list, columns }} />
      </div>
    </div>
  );
};

export default memo(SubscriptionsList);
